import React from "react";

import Page from "../../components/Page";
import DistrictFormList from "../../components/sections/districtForm/DistrictFormList";

const DistrictForms = () => {
  const breadcrumb = [
    {
      path: "/",
      breadcrumbName: "Home",
    },
    {
      path: "",
      breadcrumbName: "District forms",
    },
  ];
  return (
    <>
      <Page title="District forms" breadcrumb={breadcrumb}>
        <DistrictFormList />
      </Page>
    </>
  );
};

export default DistrictForms;
